import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select, {createFilter} from "react-select";

class PatternConstraintInput extends Component {
    state = {
        pattern_constraints: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.pattern_constraints) {
            this.setState({ pattern_constraints: this.props.pattern_constraints, isLoading: false });
        } else {
            this.fetchPatternConstraints();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.pattern_constraints !== this.state.pattern_constraints) {
            this.setState({ pattern_constraints: this.props.pattern_constraints, isLoading: false });
        }
    }

    fetchPatternConstraints = () => {
        axios.get(apiUrl + 'PatternConstraints/getPatternConstraints')
            .then(response => {
                this.setState({ pattern_constraints: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching constraints:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { pattern_constraints, isLoading, isError } = this.state;
        const { pattern_constraint_filter, patternConstraintsUpdate, updatePage, closePatternDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading constraints. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading constraints..."
                />
            );
        }

        const options =
             pattern_constraints.map(pattern_constraint => ({
                value: pattern_constraint.constraint_id,
                label: pattern_constraint.constraint_title,
                description: pattern_constraint.constraint_description,
                color: '#9999FF'
            }));
        const animatedComponents = makeAnimated();

        const defaultOptions = pattern_constraint_filter.map(pattern_constraint_id => {
            return options.find(option => option.value === pattern_constraint_id) || { value: 0, label: "Invalid pattern constraint id", color: '#9999FF' };
        });

        const constraint_description_wrapper = (description = '""') =>  ({
           ':after': {
                content: description ? ('" - ' + description + '"') : '',
                fontSize: 14,
           },
        });

        return (
            <Select
                isMulti
                isSearchable
                styles={{
                    option: (styles, { data }) => {
                        return {
                            ...styles,
                            ...constraint_description_wrapper(data.description)
                        };
                    },
                }}
                filterOption={createFilter({
                   stringify: option => `${option.label} ${option.value} ${option.data.description}`
                })}
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder={this.props.selectorText ?? "Select constraints for this pattern."}
                onChange={(val) => {
                    patternConstraintsUpdate(val);
                    updatePage(0);
                    closePatternDetails(null);
                }}
            />
        );
    }
}

export default PatternConstraintInput;